/**
 * Typed error thrown by telemetry transports on a non-2xx response (or network failure).
 * Carries the originating `statusCode` (when known) and a `retryable` flag so the
 * agent can decide retry-vs-drop without re-inspecting the status itself.
 */
export class TelemetryTransportError extends Error {
  readonly retryable: boolean;
  readonly statusCode?: number;

  /**
   * @param message - Human-readable failure description.
   * @param options - Error metadata.
   * @param options.retryable - Whether the agent should retry this batch.
   * @param options.statusCode - The HTTP status code, when a response was received.
   */
  constructor(message: string, options: { retryable: boolean; statusCode?: number }) {
    super(message);
    this.name = 'TelemetryTransportError';
    this.retryable = options.retryable;
    this.statusCode = options.statusCode;
  }
}
